import { driverIsContactable } from '@/core/validators';

export default function validateDrivers(leg) {
	let errors = {
		isInvalid: false,
	};

	if (!leg.driver && !leg.broadcastDrivers.length) {
		errors.driver = 'missingDriver';
	}
	if (leg.driver) {
		errors.driver = driverIsContactable(leg.driver);
	}
	errors.isInvalid = errors.isInvalid || Boolean(errors.driver);

	errors.broadcastDrivers = leg.broadcastDrivers.map(driver => driverIsContactable(driver));
	errors.isInvalid = errors.isInvalid || Boolean(errors.broadcastDrivers.reduce((acc, v) => acc || v, false));

	return errors;
}